import { Tabs } from 'antd';
import React, {
  Dispatch,
  FC,
  SetStateAction,
  useState,
  useEffect,
} from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import {
  CreateBranchingDetailsProps,
  FormQuestion,
  FormTemplate,
} from 'api/form/types';
import { FieldPropertiesConfiguration } from './field-properties';
import { ThemesConfiguration } from './themes';

interface Props {
  formTemplate: FormTemplate;
  selectedFormItem: number | FormQuestion | null;
  setSelectedFormItem: Dispatch<SetStateAction<null | FormQuestion | number>>;
  setCreateBranchingDetails: Dispatch<
    SetStateAction<null | CreateBranchingDetailsProps>
  >;
}

const { TabPane } = Tabs;
const StyledTabs = styled(Tabs)`
  height: 100%;

  & > .ant-tabs-content-holder {
    height: 100vh;
    & > .ant-tabs-content {
      height: 100%;
    }
  }

  .ant-tabs-tab {
    flex: 1;
    overflow: hidden;
  }

  .ant-tabs-nav {
    margin-bottom: 1px;
    box-shadow: var(--shadow-02);
  }
  .ant-tabs.na-wrap {
    background: var(--white-100);
  }
  .ant-tabs-nav-wrap .ant-tabs-nav-list {
    width: 100%;
    padding: 0px;
  }
`;

enum FieldConfigurationKeys {
  FieldProperties = 'field_properties',
  Themes = 'themes',
}

export const FormBuilderConfiguration: FC<Props> = ({
  formTemplate,
  selectedFormItem,
  setSelectedFormItem,
  setCreateBranchingDetails,
}) => {
  const [activeKey, setActiveKey] = useState<FieldConfigurationKeys>(
    FieldConfigurationKeys.FieldProperties,
  );

  useEffect(() => {
    if (selectedFormItem) {
      setActiveKey(FieldConfigurationKeys.FieldProperties);
    }
  }, [selectedFormItem]);

  return (
    <StyledTabs
      defaultActiveKey={FieldConfigurationKeys.FieldProperties}
      activeKey={activeKey}
      onChange={(value) => setActiveKey(value as FieldConfigurationKeys)}
      tabBarGutter={1}
    >
      <TabPane
        tab={<FormattedMessage id="form_templates.field_properties" />}
        key={FieldConfigurationKeys.FieldProperties}
      >
        <FieldPropertiesConfiguration
          formTemplate={formTemplate}
          selectedFormItem={selectedFormItem}
          setSelectedFormItem={setSelectedFormItem}
          setCreateBranchingDetails={setCreateBranchingDetails}
        />
      </TabPane>
      <TabPane
        tab={<FormattedMessage id="form_templates.themes" />}
        key={FieldConfigurationKeys.Themes}
      >
        <ThemesConfiguration formTemplate={formTemplate} />
      </TabPane>
    </StyledTabs>
  );
};
